import { render, staticRenderFns } from "./employees.vue?vue&type=template&id=e3871f54&scoped=true&"
import script from "./employees.vue?vue&type=script&lang=js&"
export * from "./employees.vue?vue&type=script&lang=js&"
import style0 from "./employees.vue?vue&type=style&index=0&id=e3871f54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3871f54",
  null
  
)

export default component.exports